import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import TargetFunnelConfiguration from "../Dashboard/Darts/masterConfiguration/productConfiguration/targetFunnelConfiguration";
import TargetFunnelPreview from "../Dashboard/Darts/masterConfiguration/productConfiguration/targetFunnelPreview";
import LeadIndicatorSelection from "../Dashboard/Darts/masterConfiguration/productConfiguration/leadIndicatorSelection";

const RoleInputIndicators = ({ roleId, accountId, onBack }) => {
  const location = useLocation();
  const resolvedRoleId = roleId ?? location.state?.roleId;
  const resolvedAccountId = accountId ?? location.state?.accountId;

  const [currentView, setCurrentView] = useState("funnel");
  const [targetData, setTargetData] = useState(null);
  const [leadIndicatorData, setLeadIndicatorData] = useState(null);

  if (currentView === "preview") {
    return (
      <TargetFunnelPreview
        onBack={() => setCurrentView("funnel")}
        onNext={(data) => {
          setLeadIndicatorData(data);
          setCurrentView("leadIndicator");
        }}
        targetData={targetData}
        roleId={resolvedRoleId}
        accountId={resolvedAccountId}
      />
    );
  }

  if (currentView === "leadIndicator") {
    return (
      <LeadIndicatorSelection
        onBack={() => setCurrentView("preview")}
        roleId={leadIndicatorData?.roleId ?? resolvedRoleId}
        targetFunnelName={leadIndicatorData?.targetFunnelName}
      />
    );
  }

  return (
    <TargetFunnelConfiguration
      onBack={onBack}
      onNext={(data) => {
        setTargetData(data);
        setCurrentView("preview");
      }}
      roleId={resolvedRoleId}
      accountId={resolvedAccountId}
    />
  );
};

export default RoleInputIndicators;
